import { render, staticRenderFns } from "./ProgramModuleView.vue?vue&type=template&id=52b93336&scoped=true"
import script from "./ProgramModuleView.vue?vue&type=script&lang=js"
export * from "./ProgramModuleView.vue?vue&type=script&lang=js"
import style0 from "./ProgramModuleView.vue?vue&type=style&index=0&id=52b93336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b93336",
  null
  
)

export default component.exports